import React from 'react'
import elaine from 'assets/images/elaine (1).png'

function Highlights() {
  return (
    <section className='flex min-h-svh w-full items-center justify-center bg-transparent text-black md:bg-[linear-gradient(to_right,_#FFFFFF_70%,_#FFCD00_70%)]'>
      <div className='mt-16 flex w-11/12 flex-col items-center justify-center gap-4 md:w-10/12 md:flex-row'>
        <aside className='flex flex-1 flex-col items-center justify-center gap-4 text-center md:items-start md:text-left'>
          <header className='text-4xl font-bold md:text-7xl'>+10 anos de atuação sólida</header>
          <p className='text-xl md:text-2xl'>
            Elaine, nossa fundadora, traz mais de 10 anos de experiência no mercado financeiro, assegurando a
            credibilidade e expertise que fazem da Líder Cred uma referência no setor.
          </p>
          <button className='flex transition-opacity duration-500 hover:opacity-75'>
            <a
              href='#nossos-servicos'
              className='rounded-lg bg-yellow px-6 py-3 text-lg font-semibold uppercase text-black'
            >
              Serviços
            </a>
          </button>
        </aside>

        <picture className='flex w-full flex-1 items-center justify-center'>
          <img src={elaine} loading='lazy' className='w-full rounded-xl md:w-8/12' alt='' />
        </picture>
      </div>
    </section>
  )
}

export default Highlights
